import { getCountry } from "./localization";

export const EXCLUSION_DOMAINS = [
  "localhost",
  "ford.ca",
  "fordpro.ca",
  "fleetcare.ford.com",
  "quicklane.ca",
  "voierapide.ca",
  "lincolncanada.com",
];

export const EXCLUSION_FILE_TYPES = [".pdf"];
const startsWithHttpScheme = /^https?:\/\//i;

export const EXTERNAL_URL_MARKER = "#!EXTERNAL";
const isAbsoluteUrl = (urlString: string) =>
  !!urlString && startsWithHttpScheme.test(urlString);

const hasExclusion = (href: string) =>
  !href || hasExclusionDomain(href) || hasExclusionFileType(href);

const hasExclusionDomain = (href: string) =>
  EXCLUSION_DOMAINS.some((domain) => href?.includes(domain));
const hasExclusionFileType = (href: string) =>
  EXCLUSION_FILE_TYPES.some((fileType) => href?.includes(fileType));

export const isPopupNeededForUrl = (url: string, locale: string) => {
  const isCanada = getCountry(locale) === "ca";
  const isPopupNeededForUrl =
    isAbsoluteUrl(url) &&
    !hasExclusion(url) &&
    !url.endsWith(EXTERNAL_URL_MARKER);
  return isCanada && isPopupNeededForUrl;
};
